module.exports = "/assets/packs/images/f73aa4d16399c45a98960d5fa393a6ae.png";